module.exports = __webpack_public_path__ + "img/capa.a61ec398.png";